export const type_feedback = 'feedback';
export const type_anonymous = 'anonymous';

const FormTypeSwitchItem = ({ name, activeType, type, onClick }) => {
    const handleClick = () => onClick(type);

    return (
        <button className={`form-type-change__item ${activeType === type ? 'active' : ''}`} onClick={handleClick}>
            {name}
        </button>
    );
};

const FormTypeSwitch = ({ activeType, onClick }) => (
    <div className="form-type-change">
        <FormTypeSwitchItem onClick={onClick} name={'Feedback'} activeType={activeType} type={type_feedback} />
        <FormTypeSwitchItem
            onClick={onClick}
            name={'Anonymous feedback'}
            activeType={activeType}
            type={type_anonymous}
        />
    </div>
);

export default FormTypeSwitch;
